
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function AdsPage() {
  const [selectedAdType, setSelectedAdType] = useState('all');

  const adCampaigns = [
    {
      id: 1,
      title: 'Get Your Home Cleaned by Professionals',
      type: 'Video',
      platform: 'YouTube',
      duration: '30s',
      views: '2.5M',
      thumbnail: 'https://readdy.ai/api/search-image?query=professional%20house%20cleaning%20service%20advertisement%2C%20woman%20cleaning%20modern%20home%20with%20professional%20equipment%2C%20purple%20and%20white%20branding%2C%20high%20quality%20service%20concept%2C%20clean%20and%20organized%20home%20environment&width=400&height=300&seq=ad-cleaning&orientation=landscape',
      description: 'Showcasing our professional cleaning services with real customer testimonials'
    },
    {
      id: 2,
      title: 'Download BNM Customer App - Book in Seconds',
      type: 'Display',
      platform: 'Google Ads',
      format: 'Banner',
      clicks: '850K',
      thumbnail: 'https://readdy.ai/api/search-image?query=mobile%20app%20advertisement%20banner%20showing%20smartphone%20with%20BNM%20customer%20app%20interface%2C%20purple%20design%2C%20quick%20booking%20features%2C%20user-friendly%20mobile%20application%2C%20modern%20tech%20advertisement&width=400&height=300&seq=ad-app&orientation=landscape',
      description: 'Mobile app download campaign highlighting ease of booking services'
    },
    {
      id: 3,
      title: 'Join BNM Partners - Earn ₹50K Monthly',
      type: 'Video',
      platform: 'Instagram',
      duration: '15s',
      views: '1.8M',
      thumbnail: 'https://readdy.ai/api/search-image?query=service%20partner%20earning%20money%20through%20BNM%20app%2C%20happy%20professional%20showing%20income%20on%20mobile%20screen%2C%20purple%20branding%2C%20success%20and%20financial%20growth%20concept%2C%20motivational%20advertisement&width=400&height=300&seq=ad-partner&orientation=landscape',
      description: 'Partner recruitment campaign showcasing earning potential and benefits'
    },
    {
      id: 4,
      title: 'BNM - Your Trusted Home Service Partner',
      type: 'Radio',
      platform: 'FM Radio',
      duration: '60s',
      reach: '500K',
      thumbnail: 'https://readdy.ai/api/search-image?query=radio%20studio%20with%20microphone%20and%20sound%20equipment%2C%20audio%20advertisement%20production%2C%20purple%20and%20professional%20theme%2C%20broadcasting%20and%20media%20concept%2C%20modern%20radio%20station%20setup&width=400&height=300&seq=ad-radio&orientation=landscape',
      description: 'Radio spot highlighting trust, safety, and convenience of BNM services'
    },
    {
      id: 5,
      title: 'Beauty Services at Your Doorstep',
      type: 'Social',
      platform: 'Facebook',
      format: 'Carousel',
      engagement: '95K',
      thumbnail: 'https://readdy.ai/api/search-image?query=beauty%20and%20grooming%20services%20at%20home%20advertisement%2C%20professional%20beautician%20providing%20salon%20services%20at%20customer%20home%2C%20purple%20branding%2C%20convenience%20and%20luxury%20concept&width=400&height=300&seq=ad-beauty&orientation=landscape',
      description: 'Social media campaign promoting at-home beauty and grooming services'
    },
    {
      id: 6,
      title: 'BNM Appliance Repair - Fix It Fast',
      type: 'Display',
      platform: 'Google Ads',
      format: 'Responsive',
      impressions: '2.2M',
      thumbnail: 'https://readdy.ai/api/search-image?query=appliance%20repair%20service%20advertisement%2C%20technician%20fixing%20washing%20machine%20and%20other%20home%20appliances%2C%20professional%20tools%20and%20equipment%2C%20BNM%20purple%20branding%2C%20quick%20and%20reliable%20service&width=400&height=300&seq=ad-repair&orientation=landscape',
      description: 'Display campaign for appliance repair services with quick response messaging'
    }
  ];

  const adTypes = ['all', 'Video', 'Display', 'Social', 'Radio'];

  const filteredAds = selectedAdType === 'all' 
    ? adCampaigns 
    : adCampaigns.filter(ad => ad.type === selectedAdType);

  const brandGuidelines = [
    {
      title: 'Logo Usage',
      description: 'Proper usage of BNM logo in advertisements',
      icon: 'ri-image-line'
    },
    {
      title: 'Color Palette',
      description: 'Official brand colors and their applications',
      icon: 'ri-palette-line'
    },
    {
      title: 'Typography',
      description: 'Approved fonts and text styling guidelines',
      icon: 'ri-font-size-2'
    },
    {
      title: 'Voice & Tone',
      description: 'Brand messaging and communication style',
      icon: 'ri-chat-voice-line'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
               style={{
                 backgroundImage: `url('https://readdy.ai/api/search-image?query=creative%20advertising%20agency%20with%20multiple%20screens%20showing%20BNM%20advertisements%2C%20modern%20marketing%20campaigns%2C%20purple%20and%20white%20branding%2C%20creative%20professionals%20working%20on%20ad%20campaigns%2C%20success%20and%20brand%20visibility&width=1200&height=600&seq=ads-hero&orientation=landscape')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center'
               }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              BNM Advertising Gallery
            </h1>
            <p className="text-xl mb-8">
              Explore our creative campaigns and brand marketing initiatives
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-video-line mr-2"></i>
                <span>Video Campaigns</span>
              </div>
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-advertisement-line mr-2"></i>
                <span>Display Ads</span>
              </div>
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-share-line mr-2"></i>
                <span>Social Media</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Campaign Performance */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Campaign Performance</h2>
            <p className="text-xl text-gray-600">Our advertising reach and impact</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-2xl text-purple-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">10M+</div>
              <p className="text-gray-600">Total Impressions</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-play-circle-line text-2xl text-blue-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">5M+</div>
              <p className="text-gray-600">Video Views</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mouse-line text-2xl text-green-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">1.5M+</div>
              <p className="text-gray-600">Ad Clicks</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-2xl text-red-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">500K+</div>
              <p className="text-gray-600">Engagements</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ad Gallery */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Ad Campaigns</h2>
            <p className="text-xl text-gray-600">Creative campaigns across all platforms</p>
          </div>

          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {adTypes.map((type) => (
              <button
                key={type}
                onClick={() => setSelectedAdType(type)}
                className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  selectedAdType === type
                    ? 'bg-purple-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-purple-100'
                }`}
              >
                {type === 'all' ? 'All Campaigns' : type + ' Ads'}
              </button>
            ))}
          </div>

          {/* Ad Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {filteredAds.map((ad) => (
              <div key={ad.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
                <div className="aspect-video bg-gray-100 overflow-hidden">
                  <img 
                    src={ad.thumbnail} 
                    alt={ad.title} 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-xs font-medium">
                      {ad.type}
                    </span>
                    <span className="text-sm text-gray-500">{ad.platform}</span>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">{ad.title}</h3>
                  <p className="text-gray-600 text-sm mb-4">{ad.description}</p>
                  
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    {ad.duration && (
                      <span className="flex items-center">
                        <i className="ri-time-line mr-1"></i>
                        {ad.duration}
                      </span>
                    )}
                    {ad.views && (
                      <span className="flex items-center">
                        <i className="ri-eye-line mr-1"></i>
                        {ad.views}
                      </span>
                    )}
                    {ad.clicks && (
                      <span className="flex items-center">
                        <i className="ri-mouse-line mr-1"></i>
                        {ad.clicks}
                      </span>
                    )}
                    {ad.reach && (
                      <span className="flex items-center">
                        <i className="ri-radio-line mr-1"></i>
                        {ad.reach}
                      </span>
                    )}
                    {ad.engagement && (
                      <span className="flex items-center">
                        <i className="ri-heart-line mr-1"></i>
                        {ad.engagement}
                      </span>
                    )}
                    {ad.impressions && (
                      <span className="flex items-center">
                        <i className="ri-bar-chart-line mr-1"></i>
                        {ad.impressions}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Guidelines */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Brand Guidelines</h2>
            <p className="text-xl text-gray-600">Maintaining consistent brand identity across all campaigns</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {brandGuidelines.map((guideline, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${guideline.icon} text-2xl text-purple-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{guideline.title}</h3>
                <p className="text-gray-600">{guideline.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <button className="bg-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap">
              Download Brand Guidelines
            </button>
          </div>
        </div>
      </section>

      {/* Creative Process */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Creative Process</h2>
            <p className="text-xl text-gray-600">How we create impactful advertising campaigns</p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Strategy</h3>
              <p className="text-gray-600 text-sm">Define campaign objectives and target audience</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Concept</h3>
              <p className="text-gray-600 text-sm">Develop creative concepts and messaging</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Production</h3>
              <p className="text-gray-600 text-sm">Create high-quality ad content and materials</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-xl font-bold">4</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Launch</h3>
              <p className="text-gray-600 text-sm">Deploy campaigns and monitor performance</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Marketing Team */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Work With Our Marketing Team</h2>
          <p className="text-xl text-gray-600 mb-8">
            Interested in partnerships or advertising opportunities?
          </p>
          
          <div className="max-w-2xl mx-auto">
            <div className="bg-purple-50 rounded-2xl p-8 border border-purple-100">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-marketing-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Marketing & Partnerships</h3>
              
              <div className="space-y-4">
                <div className="flex items-center justify-center">
                  <i className="ri-mail-line text-purple-600 mr-3"></i>
                  <a href="mailto:marketing@baainearme.com" className="text-gray-700 hover:text-purple-600 cursor-pointer">
                    marketing@baainearme.com
                  </a>
                </div>
                
                <div className="flex items-center justify-center">
                  <i className="ri-phone-line text-purple-600 mr-3"></i>
                  <a href="tel:93074 19845" className="text-gray-700 hover:text-purple-600 cursor-pointer">
                    +91 93074 19845
                  </a>
                </div>
              </div>
              
              <button className="bg-purple-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap mt-6">
                Get In Touch
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Creative campaigns that connect and inspire
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Advertising</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer">Video Campaigns</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Display Ads</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Social Media</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Resources</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/press" className="hover:text-white cursor-pointer">Press Kit</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <ul className="space-y-2 text-gray-400">
                <li>📧 marketing@baainearme.com</li>
                <li>📞 +91 93074 19845</li>
                <li>📍 Nagpur, Maharashtra</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
